// extracted by mini-css-extract-plugin
module.exports = {"inputArea":"styles_inputArea__QX9av","appliedInputArea":"styles_appliedInputArea__kQ5AA"};